<section class="section-calendar">
  <div class="container-calendar">
    <h3 class="input-title-blue">{{"SelectDate" |translate}}</h3>
    <mat-calendar
      [(selected)]="calendarTime"
      class="calendar"
      (click)="SelectDateDinamic()"
      [dateFilter]="dateFilter"
    ></mat-calendar>
  </div>
  <div class="container-select-hour">
    <h3 class="input-title-blue">{{"SelectHour" |translate}}</h3>
    <div class="content-btn-hour" *ngIf="isDateSelected; else hourNotSelected">
      <div class="btn-hour-for" *ngFor="let timehour of timeListButtons">
        <button
          mat-raised-button
          class="btn-hour"
          (click)="timeValue(timehour)"
          name="timeButton"
        >
          {{ timehour }}
        </button>
      </div>
    </div>
    <ng-template #hourNotSelected>
      <i>{{"NoDateSelected" |translate}}</i>
    </ng-template>
    <div *ngIf="timeListButtons.length === 0">
      <i>{{"NoHoursSelected" |translate}}</i>
    </div>
  </div>
</section>
